/* =============================================================
   Plek in Bloei — sectiegedrag
   Verzorgingswijzer en sorteren/filteren.
   ============================================================= */

(function (PIB) {
  'use strict';

  /* ---- verzorgingswijzer ---- */

  PIB.register('wijzer', function (root) {
    root.querySelectorAll('[data-wijzer]').forEach(function (wijzer) {
      if (!PIB.eenmalig(wijzer, 'wijzerGebonden')) return;

      var stappen = Array.prototype.slice.call(wijzer.querySelectorAll('[data-wijzer-stap]'));
      var uitkomst = wijzer.querySelector('[data-wijzer-uitkomst]');
      var samenvatting = wijzer.querySelector('[data-wijzer-samenvatting]');
      var link = wijzer.querySelector('[data-wijzer-link]');
      var meter = wijzer.querySelector('[data-wijzer-meter]');
      var teller = wijzer.querySelector('[data-wijzer-tel]');
      var basis = (wijzer.dataset.basis || '/collections/all').replace(/\/$/, '');

      if (!stappen.length || !uitkomst) return;

      function toon(i) {
        stappen.forEach(function (s, n) { s.hidden = n !== i; });
        uitkomst.hidden = true;
        if (meter) meter.style.width = (i / stappen.length * 100) + '%';
        if (teller) teller.textContent = (i + 1) + ' / ' + stappen.length;

        if (i > 0) {
          var kop = stappen[i].querySelector('legend');
          if (kop) kop.scrollIntoView({ block: 'nearest', behavior: PIB.kalm ? 'auto' : 'smooth' });
        }
      }

      function afronden() {
        var tags = [];
        samenvatting.innerHTML = '';

        stappen.forEach(function (stap) {
          var aan = stap.querySelector('input:checked');
          if (!aan) return;
          if (aan.value) tags.push(aan.value);

          var regel = document.createElement('li');
          var vraag = document.createElement('span');
          var antwoord = document.createElement('span');
          vraag.textContent = stap.querySelector('legend').textContent.trim();
          antwoord.textContent = aan.dataset.label || '';
          regel.append(vraag, antwoord);
          samenvatting.appendChild(regel);
        });

        link.href = tags.length ? basis + '/' + tags.join('+') : basis;

        stappen.forEach(function (s) { s.hidden = true; });
        uitkomst.hidden = false;
        if (meter) meter.style.width = '100%';
        if (teller) teller.textContent = stappen.length + ' / ' + stappen.length;
      }

      stappen.forEach(function (stap, i) {
        var verder = stap.querySelector('[data-wijzer-verder]');
        var terug = stap.querySelector('[data-wijzer-terug]');

        if (terug && i > 0) terug.hidden = false;

        stap.addEventListener('change', function () { if (verder) verder.disabled = false; });

        if (verder) {
          verder.addEventListener('click', function () {
            if (i + 1 < stappen.length) toon(i + 1);
            else afronden();
          });
        }
        if (terug) terug.addEventListener('click', function () { toon(Math.max(0, i - 1)); });
      });

      var opnieuw = wijzer.querySelector('[data-wijzer-opnieuw]');
      if (opnieuw) {
        opnieuw.addEventListener('click', function () {
          wijzer.querySelectorAll('input:checked').forEach(function (v) { v.checked = false; });
          wijzer.querySelectorAll('[data-wijzer-verder]').forEach(function (k) { k.disabled = true; });
          toon(0);
        });
      }

      toon(0);
    });
  });

  /* ---- sorteren en filteren zonder knop ---- */

  PIB.register('filters', function (root) {
    root.querySelectorAll('[data-auto-verzenden]').forEach(function (veld) {
      if (!PIB.eenmalig(veld, 'autoGebonden')) return;
      veld.addEventListener('change', function () { if (veld.form) veld.form.submit(); });
    });
  });
})(window.PIB);
